export const normalizeSlug = (value?: string | null) =>
  value?.replace(/^\/|\/$/g, "");
